
import Vue from 'vue'
import { RecordingStatus } from '~/constants/speech-recognition'
export default Vue.extend({
  props: {
    maxLength: {
      type: Number,
      default: 70,
      required: false
    }
  },
  data: () => ({
    SpeechRecognitionAPI: null,
    status: RecordingStatus.IDLE,
    recognizer: null,
    finalTranscript: ''
  }),
  mounted() {
    this.SpeechRecognitionAPI =
      window.webkitSpeechRecognition || window.SpeechRecognition

    if (this.SpeechRecognitionAPI) {
      this.$emit('hasMic', true)
    }
  },
  methods: {
    // https://codeburst.io/html5-speech-recognition-api-670846a50e92
    record() {
      if (this.status === RecordingStatus.RECORDING && this.recognizer) {
        this.recognizer.stop()
        this.recognizer = null
      } else {
        this.status = RecordingStatus.RECORDING
        this.recognizer = new this.SpeechRecognitionAPI()
        this.recognizer.interimResults = true
        this.recognizer.maxAlternatives = 1
        this.recognizer.continuous = false
        this.recognizer.lang = this.$i18n.locale === 'el' ? 'el-GR' : 'en-US'
        this.setupListeners(this.recognizer)

        this.recognizer.start()
      }
    },
    setupListeners(recognizer) {
      const _self = this
      recognizer.onresult = event => {
        let interimTranscript = ''
        for (
          let i = event.resultIndex, len = event.results.length;
          i < len;
          i++
        ) {
          const transcript = event.results[i][0].transcript
          if (event.results[i].isFinal) {
            _self.finalTranscript += transcript
          } else {
            interimTranscript += transcript
          }

          if (
            interimTranscript.length > this.maxLength ||
            _self.finalTranscript.length > this.maxLength
          ) {
            _self.recognizer.stop()
          }
        }
        this.$emit('interimTranscript', interimTranscript)
      }
      recognizer.onend = () => {
        _self.onStop()
      }
    },
    onStop() {
      this.$emit('finalTranscript', this.finalTranscript)
      this.finalTranscript = ''
      this.status = RecordingStatus.IDLE
    }
  }
})
